import { useRef, useState } from "react";
import style from "./ExpireCard.module.css";
import { cardType } from "../../../types/game";
import { vibratePhone } from "../../../helpers/share";
import ShareBox from "../../shareButton/ShareBox";

interface cardProp extends cardType {
  className?: string;
  result?: boolean;
  small?: boolean;
}

const ExpireCard: React.FC<cardProp> = (card) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copyText, setCopyText] = useState<string>("copy");
  const handleCopy = function () {
    vibratePhone(20);
    setCopyText("tick");
    setTimeout(() => {
      setCopyText("copy");
    }, 2000);
    try {
      navigator.clipboard.writeText(card.code);
    } catch (error) {
      inputRef.current?.select();
      document.execCommand("copy");
    }
  };
  return (
    <div className={`${style.card} ${card.className ? card.className : ""}`}>
      <div
        className={`${style.inner} ${
          card.amount === 100 ? style.goldencard : ""
        }`}
      >
        <div className={style.content}>
          {card.result && (
            <div className={style.title}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/mini-star-gold.svg`}
                alt=""
              />
              <span> بانی‌مد برات یه سورپرایز داره!</span>
            </div>
          )}
          <div className={style.code}>
            <div className="flex w-full items-center justify-center">
              <span className={style["code-right_title"]}>{card.title}</span>
            </div>
          </div>

          {!!card.detail && (
            <div className={style.description}>
              <span>{card.detail}</span>
            </div>
          )}
          <div className={style["expire-wrapper"]}>
            <div className={style.expire}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/expire.svg`}
                alt=""
              />
              <span> مهلت استفاده:{card.expire_text}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ExpireCard;
